const BASE_URL = "/api";

export function getToken() {
  return localStorage.getItem("token");
}

export async function apiFetch(path, options = {}) {
  const url = `${BASE_URL}${path}`;

  const headers = { ...(options.headers || {}) };
  const token = getToken();
  if (token && !headers.Authorization) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(url, { ...options, headers });

  if (res.status === 401) {
    // Session expired — clear token and send the user back to login
    localStorage.removeItem("token");
    if (window.location.pathname !== "/") {
      window.location.href = "/";
    }
    throw new Error("Session expired. Please sign in again.");
  }

  if (!res.ok) {
    let message = `API Error ${res.status}`;
    try {
      const body = await res.json();
      if (body.detail) {
        message =
          typeof body.detail === "string"
            ? body.detail
            : JSON.stringify(body.detail);
      }
    } catch {
      // non-JSON error body — keep generic message
    }
    throw new Error(message);
  }

  if (res.status === 204) return null;
  return res.json();
}

export { BASE_URL };
